import { SIDEBAR_WIDTH_VAR } from '../sidebar'

export const SNACKBAR_SX = {
  p: 0,
  left: `calc(50% + var(${SIDEBAR_WIDTH_VAR}, 0px) / 2)`,
} as const
